import { fetchAdminV1 } from "../lib/requester/v1";

export function populateAllParameters() {
	return fetchAdminV1("/campaign_matching_parameters/populate/all", { method: "GET" });
}
export function populateParameters(campaignId) {
	return fetchAdminV1(`/campaign_matching_parameters/populate/${campaignId}`, { method: "GET" });
}
